import { TFilterSortBy } from '../../../../../../types';

export const convertFormValuesToStoreData = (values: {[key: string]: string}) => {
    const filterProviders = Object.keys(values).filter((key) => key.startsWith('games-grid-filters-provider-') && Boolean(values[key]))
        .map((key) => key.replace('games-grid-filters-provider-', ''))
        .join(',');

    const filterLabels = Object.keys(values).filter((key) => key.startsWith('games-grid-filters-label-') && Boolean(values[key]))
        .map((key) => key.replace('games-grid-filters-label-', ''))
        .join(',');

    const filterCategory = Object.keys(values).filter((key) => key.startsWith('games-grid-filters-category-') && Boolean(values[key]))
        .map((key) => key.replace('games-grid-filters-category-', ''))
        .join(',');

    const filterCustomFields = Object.keys(values).filter((key) => key.startsWith('games-grid-filters-customField-'))
        .reduce((acc, key) => {
            if (!values[key]) {
                return acc;
            }

            const [fieldName, value] = key.replace('games-grid-filters-customField-', '').split('-');

            if (!acc[fieldName]) {
                acc[fieldName] = '';
            }

            acc[fieldName] += `${acc[fieldName] ? ',' : ''}${value}`;

            return acc;
    }, {} as { [key: string]: string });

    return {
        filterCategory,
        filterLabels,
        filterProviders,
        filterCustomFields,
        filterSortBy: values['games-grid-filters-sort-by'] as TFilterSortBy
    };
};

export const convertStoreDataToFormValues = (formInitialValues: {
        filterCategory: string;
        filterLabels: string;
        filterProviders: string;
        filterSortBy: TFilterSortBy;
        filterCustomFields: {[key: string]: string};
}) => {
    const {
        filterSortBy,
        filterLabels,
        filterCategory,
        filterProviders,
        filterCustomFields
    } = formInitialValues;

    const providerInitialValues = (filterProviders && filterProviders.split(',') || []).reduce((acc, provider) => {
        acc[`games-grid-filters-provider-${provider}`] = true;

        return acc;
    }, {} as { [key: string]: boolean });

    const labelInitialValues = (filterLabels && filterLabels.split(',') || []).reduce((acc, label) => {
        acc[`games-grid-filters-label-${label}`] = true;

        return acc;
    }, {} as { [key: string]: boolean });

    const categoryInitialValues = (filterCategory && filterCategory.split(',') || []).reduce((acc, label) => {
        acc[`games-grid-filters-category-${label}`] = true;

        return acc;
    }, {} as { [key: string]: boolean });

    const customFieldsInitialValues = Object.keys(filterCustomFields || {}).reduce((acc, key) => {
        const values = filterCustomFields[key]?.split(',') || [];

        values.forEach((value) => {
            acc[`games-grid-filters-customField-${key}-${value}`] = true;
        });

        return acc;
    }, {} as { [key: string]: boolean });

    return {
        'games-grid-filters-sort-by': filterSortBy,
        ...providerInitialValues,
        ...labelInitialValues,
        ...categoryInitialValues,
        ...customFieldsInitialValues
    };
};
